import { faArrowUp, faLocationCrosshairs, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';

const RunFloatingControls = ({
  scannedPieceUuid,
  hasScannedPieceInRun,
  hasDismissedScannedPieceLocator,
  scannedPieceSnapshotUrl,
  scannedPieceGroupIndex,
  onJump,
  onDismissLocator,
  showBackToTop,
  onBackToTop,
}) => (
  <>
    {Boolean(scannedPieceUuid) && hasScannedPieceInRun && !hasDismissedScannedPieceLocator && (
      <div className="scanned-piece-locator">
        <span className="scanned-piece-locator__icon" aria-hidden="true">
          {scannedPieceSnapshotUrl ? (
            <img src={scannedPieceSnapshotUrl} alt="" className="scanned-piece-locator__image" />
          ) : (
            <FontAwesomeIcon icon={faLocationCrosshairs} />
          )}
        </span>
        <span className="scanned-piece-locator__copy">
          <span className="scanned-piece-locator__label">Scanned Piece</span>
          {scannedPieceGroupIndex !== null && (
            <span className="scanned-piece-locator__meta">Group {scannedPieceGroupIndex + 1}</span>
          )}
        </span>
        <button
          type="button"
          className="scanned-piece-locator__action"
          onClick={onJump}
        >
          Jump
        </button>
        <button
          type="button"
          className="scanned-piece-locator__close"
          aria-label="Hide scanned piece locator"
          onClick={onDismissLocator}
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>
    )}
    {showBackToTop && (
      <button
        type="button"
        className="run-back-to-top"
        aria-label="Scroll to top"
        onClick={onBackToTop}
      >
        <FontAwesomeIcon icon={faArrowUp} />
      </button>
    )}
  </>
);

RunFloatingControls.propTypes = {
  scannedPieceUuid: PropTypes.string,
  hasScannedPieceInRun: PropTypes.bool.isRequired,
  hasDismissedScannedPieceLocator: PropTypes.bool.isRequired,
  scannedPieceSnapshotUrl: PropTypes.string,
  scannedPieceGroupIndex: PropTypes.number,
  onJump: PropTypes.func.isRequired,
  onDismissLocator: PropTypes.func.isRequired,
  showBackToTop: PropTypes.bool.isRequired,
  onBackToTop: PropTypes.func.isRequired,
};

RunFloatingControls.defaultProps = {
  scannedPieceUuid: null,
  scannedPieceSnapshotUrl: null,
  scannedPieceGroupIndex: null,
};

export default RunFloatingControls;
